import styled, { css } from 'styled-components'

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.space['16']};
    padding: ${theme.space['48']} ${theme.space['24']};
  `,
)

export const Image = styled.img<{ $width?: string }>(
  ({ $width }) => css`
    width: ${$width ? $width : '8rem'};
    height: auto;
  `,
)

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.space['8']};
    text-align: center;
    max-width: 28rem;
  `,
)

export const Actions = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.space['12'],
}))
